import ModeSelector from './navbar/ModeSelector'
import NeuroLogo    from './logo/NeuroLogo'

export default class Navbar extends React.PureComponent
  constructor: (props) ->
    super(props)

    @state =
      mobileNavbarIsOpen: false

    # Use a reference for Bootstrap's collapsible navbar (mobile view)
    @collapseRef = React.createRef()

    # Bound methods
    @changeMode = @changeMode.bind(this)

  componentDidMount: ->
    # We watch the opening and closing of Bootstrap's mobile navbar,
    # so we can synchronize our state with it
    @collapseRef.current.addEventListener('show.bs.collapse', (event) =>
      @setState(mobileNavbarIsOpen: true)
    )

    @collapseRef.current.addEventListener('hide.bs.collapse', (event) =>
      @setState(mobileNavbarIsOpen: false)
    )

  changeMode: (mode) ->
    # Close the mobile menu (if open) when changing mode
    if @state.mobileNavbarIsOpen
      Bootstrap.Collapse.getInstance(@collapseRef.current).hide()

    if @props.changeMode
      @props.changeMode(mode) # on main Neurooo page
    else
      window.location.href = "/#{@props.currentLocale}/#{mode}" # on other pages

  render: ->
    <nav className="navbar navbar-expand-md" role="navigation">
      <div className="container-lg navbar-container">
        { @renderNavbarBrand() }
        { @renderToggler() }
        { @renderMainNavbar() }
      </div>
    </nav>

  renderNavbarBrand: ->
    <div className="navbar-brand">
      <a href={"/#{@props.currentLocale}"} title="Neurooo">
        <NeuroLogo />
      </a>
      { @renderProSpan() }
    </div>

  renderProSpan: ->
    if @props.currentUser?.isPro
      <span className="pro-span" title={@props.i18n.logo.proTitle}>
        Pro
      </span>

  renderToggler: ->
    <button className="navbar-toggler collapsed"
            ref={@togglerRef}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#main-navbar"
            aria-controls="main-navbar"
            aria-expanded="false"
            aria-label={@props.i18n.togglerLabel} >
      <i className="fas fa-bars"></i>
      <i className="fas fa-xmark"></i>
    </button>

  renderMainNavbar: ->
    <div className="navbar-collapse collapse" id="main-navbar" ref={@collapseRef}>
      { @renderSlider() }
      { @renderActions() }
      { @renderUserActions() }
    </div>

  renderSlider: ->
    <ModeSelector activeMode={@props.mode}
                  changeMode={@changeMode}
                  mobileNavbarIsOpen={@state.mobileNavbarIsOpen}
                  currentLocale={@props.currentLocale}
                  i18n={@props.i18n} />

  renderActions: ->
    <div className="actions navbar-nav">
      <div className="text-nowrap mx-3">
        { @renderProLink() }

        <a href={@props.paths.apiPath} className="link link-api d-inline me-0 me-xl-2 me-xxl-4" type="button">
          { @props.i18n.api }
        </a>
      </div>

      <a href="/#{@props.currentLocale}/blog" className="link link-blog d-inline d-md-none d-xl-inline" type="button">
        { @props.i18n.blog }
        { @renderBlogBadge() }
      </a>
    </div>

  renderProLink: ->
    if !@props.currentUser?.isPro
      <a href={"/#{@props.currentLocale}/#pricing"}
         type="button"
         className="link link-pro d-inline">
        Pro
      </a>

  renderBlogBadge: ->
    if @props.blogNotification
      <span className="badge rounded-pill">
        1 <span className="visually-hidden">{@props.i18n.unreadArticles}</span>
      </span>

  # Temporary buttons, for easy access to log-in and sign-up pages (+ sign-out button)
  # TODO: open modals when signed-out + display dropdown user menu when signed-in
  renderUserActions: ->
    if @props.currentUser
      <ul className="navbar-nav navbar-user">
        <li className="nav-item dropdown">
          <a href="#" className="nav-link" id="nav-link-user" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
            <img src={ @props.currentUser.avatarUrl } width="34" height="34" referrerPolicy="no-referrer"/>
            <div className="username-for-mobile">
              { @props.currentUser.name }
            </div>
          </a>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="nav-link-user">
            { @renderSignedInAs() }
            { @renderAccountType() }
            <li><hr className="dropdown-divider mt-0 border-0"/></li>
            <li>
              <a className="dropdown-item" href={@props.paths.accountPath}>
                {@props.i18n.manageAccount}
              </a>
            </li>
            <li><hr className="dropdown-divider"/></li>
            <li>
              <a className="dropdown-item text-danger" href={@props.paths.signOutPath} data-method="delete">
                {@props.i18n.signOut}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    else
      <div className="navbar-nav navbar-visitor">
        <a href="#{@props.paths.signInPath}" className="btn sign-in">
          {@props.i18n.logIn}
        </a>
        <a href="#{@props.paths.signUpPath}" className="btn btn-primary sign-up">
          {@props.i18n.signUp}
        </a>
      </div>

  renderSignedInAs: ->
    <li className="dropdown-item signed-in-as">
      <span>{@props.i18n.signedInAs} </span>
      <a href={@props.paths.accountPath} title={@props.currentUser.name}>
        {@props.currentUser.name}
      </a>
    </li>

  renderAccountType: ->
    classes = "dropdown-item account-type"

    if @props.currentUser?.isPro
      <li className={"#{classes} pro-account"}>
        <a href={@props.paths.subscriptionsPath}>
          {@props.i18n.accountType.pro}
        </a>
      </li>
    else
      <li className={"#{classes} free-account"}>
        {@props.i18n.accountType.free}
        <a href={"/#{@props.currentLocale}/#pricing"}
           className="btn btn-outline-primary btn-upgrade">
          {@props.i18n.accountType.upgrade}
        </a>
      </li>
